import { useState } from 'react';
import { PaymentMethod } from '../types';
import { AdyenChangePayload } from '../components/payment';

export function useAdyenPayload() {
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod | undefined>();

  const onPaymentChange = (payload: AdyenChangePayload | null) => {
    if (payload?.isValid && payload?.data.paymentMethod) {
      const paymentMethod: PaymentMethod = {
        type: payload.data.paymentMethod.type,
        encryptedCardNumber: payload.data.paymentMethod.encryptedCardNumber,
        encryptedExpiryMonth: payload.data.paymentMethod.encryptedExpiryMonth,
        encryptedExpiryYear: payload.data.paymentMethod.encryptedExpiryYear,
        encryptedSecurityCode: payload.data.paymentMethod.encryptedSecurityCode,
        holderName: payload.data.paymentMethod.holderName,
        encryptedBankAccountNumber: payload.data.paymentMethod.encryptedBankAccountNumber,
        encryptedBankLocationId: payload.data.paymentMethod.encryptedBankLocationId,
        ownerName: payload.data.paymentMethod.ownerName,
      };

      setPaymentMethod(paymentMethod);
    } else {
      setPaymentMethod(undefined);
    }
  };

  return { paymentMethod, onPaymentChange };
}
